import { useEffect, useRef } from "react";
import { X } from "lucide-react";

export default function VideoModal({ isOpen, onClose, videoUrl, title }) {
  const videoRef = useRef(null);

  // Luk på Escape-tast
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Escape") {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener("keydown", handleKeyDown);
      // Forhindr scrolling på baggrunden, når modalen er åben
      document.body.style.overflow = "hidden";
    }

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
      document.body.style.overflow = "unset";
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/90 backdrop-blur-md p-4 transition-opacity duration-300"
      onClick={onClose}
      role="dialog"
      aria-modal="true"
    >
      {/* Container */}
      <div
        className="relative w-full max-w-4xl max-h-[90vh] flex flex-col items-center justify-center"
        onClick={(e) => e.stopPropagation()} // Forhindr lukning ved klik på selve videoen/containeren
      >
        {/* Luk-knap */}
        <button
          onClick={onClose}
          className="absolute -top-12 right-0 md:-right-12 text-white/80 hover:text-white bg-black/40 hover:bg-black/60 p-2.5 rounded-full transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-white/50"
          aria-label="Luk video"
        >
          <X className="h-6 w-6" />
        </button>

        {/* Titel (valgfri) */}
        {title && (
          <div className="absolute -top-10 left-2 text-white/90 text-sm font-medium tracking-wide hidden md:block">
            {title}
          </div>
        )}

        {/* Video-element */}
        <div className="w-full h-full flex items-center justify-center rounded-xl overflow-hidden shadow-2xl bg-black">
          <video
            ref={videoRef}
            src={videoUrl}
            className="max-h-[80vh] max-w-full object-contain"
            controls
            autoPlay
            playsInline
          />
        </div>
      </div>
    </div>
  );
}
